module.exports = __webpack_public_path__ + "static/media/whatsapp.8b09f497.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/socialMedia/whatsapp.svg
// module id = 2316
// module chunks = 0